import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { tooltipConstants } from '../../constants/tooltip.consts';
import { TableTooltip } from '@ui/aos-lib/';

export const deviceHealthTooltip: TableTooltip = {
  title: TranslateRegistry.get.TOOLTIP.TITLE.DEVICE_HEALTH,
  text: tooltipConstants.healthStatus,
  maxWidth: 16.6
};

export const lastHeardTooltip: TableTooltip = {
  title: TranslateRegistry.get.TOOLTIP.TITLE.LAST_HEARD,
  text: tooltipConstants.lastHeard,
  maxWidth: 14.7
};

export const deviceIdTooltip: TableTooltip = {
  title: TranslateRegistry.get.TOOLTIP.TITLE.DEVICE_ID,
  text: tooltipConstants.deviceId,
  maxWidth: 18.3
};

export const batteryStatusTooltip = {
  title: TranslateRegistry.get.TOOLTIP.TITLE.BATTERY_STATUS,
  text: tooltipConstants.batteryToolTipCommon,
  maxWidth: 18.5
};

export const transmissionReadRateTooltip = {
  title: TranslateRegistry.get.TOOLTIP.TITLE.TRANSMISSION_READ_RATE,
  text: tooltipConstants.transmissionReadRate,
  maxWidth: 17.9
};

export const validReadRateTooltip = {
  title: TranslateRegistry.get.TOOLTIP.TITLE.VALID_TRANSMISSION_READ_RATE,
  text: tooltipConstants.validReadRate,
  maxWidth: 18.25
};
